
<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-on="on" style="border-radius: 8px;" >
          <v-avatar left>
            <v-icon>mdi-calendar</v-icon>
          </v-avatar>
          Mês: {{$moment(date).format('MM/YYYY')}}
        </v-chip>
        <!-- <v-text-field filled rounded v-bind="attrs" v-on="on" :value="$moment(date).format('DD/MM/YYYY')" readonly ></v-text-field> -->
      </template>
      <v-date-picker v-model="date" type='month' no-title scrollable >
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="menu = false" >
          Cancelar
        </v-btn>
        <v-btn text color="secondary" @click="saveDate()" >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'DateFilter',
  props: {
    date_change_from_component: {
      type: String,
    },
  },
  data() {
    return {
      menu: false,
      date: new Date().toISOString().substring(0,10),
    }
  },
  mounted () {
    console.log(this.date_change_from_component);
  },
  methods: {
    saveDate() {
      this.$refs.menu.save(this.date)
      console.log(this.date)
      this.$emit('savedDate', `${this.date}-01`)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    date_change_from_component(nv, ov) {
      console.log({nv}, {ov})
      if (nv != this.date) {
        this.date = nv
      }
    }
  },
}
</script>

<style scoped>

</style>